// extracted by mini-css-extract-plugin
module.exports = {"productsWrapper":"styles_productsWrapper__2Lfyw","productsList":"styles_productsList__1TFQu","link":"styles_link__1cZ5d"};